import { action } from "typesafe-actions";
import { IDate } from "../../components/Table/hooks/useDateFilter";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../api/api";
import {
  convertLoaderCompleted,
  convertLoaderProgress,
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";
import { IQueryParams } from "../common/common.types";
import { getSearchQuery } from "../common/helpers";
import { makeApiCall } from "../../helpers/postRequest";
import { endPoints } from "../../constants/endPoints";
import { IDataTableV2DateState } from "../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { getDataTablev2InitialDate } from "../../components/TableV2/helpers/dataTableV2DatesFilter";
import { formatDate, formatDate2 } from "../../helpers";
import { ILeadfromWebsite } from "./leadsfromwebsite.types";

export const FETCH_LEADS_FROM_WEBSITE_PROGRESS = "FETCH_LEADS_FROM_WEBSITE_PROGRESS";
export const FETCH_LEADS_FROM_WEBSITE_SUCCESS = "FETCH_LEADS_FROM_WEBSITE_SUCCESS";
export const FETCH_LEADS_FROM_WEBSITE_FAILED = "FETCH_LEADS_FROM_WEBSITE_FAILED";

export const fetchLeadsFromWebsiteProgress = () => action(FETCH_LEADS_FROM_WEBSITE_PROGRESS);
export const fetchLeadsFromWebsiteSuccess = (list: ILeadfromWebsite[], totalRecords: number) =>
  action(FETCH_LEADS_FROM_WEBSITE_SUCCESS, { list, totalRecords });
export const fetchLeadsFromWebsiteFailed = () => action(FETCH_LEADS_FROM_WEBSITE_FAILED);

export const fetchLeadsFromWebsiteAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter,
    // companyOutletUuid: string,
    searchByName: string,
    searchByNo: string,
    // searchByVenue: string,
    

    searchByWhatsappStatus: string,
    searchByCompanyName: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsFromWebsiteProgress());

      let url = "";
      if (status !== "-1") {
        url += `&status=${status}`;
      }
      // if (searchValue.length > 0) {
      // 	url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      // }

      // if (searchByName) {
      // 	const advanceFilter = [
      // 		{
      // 			column: ["name_of_guest"],
      // 			value: searchByName,
      // 			logicalOperator: "OR",
      // 			operator: "CONTAINS",
      // 		},
      // 	];
      // 	url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      // }
      // if (companyOutletUuid) {
      //   url += `&company_outlet_uuid=${companyOutletUuid}`;
      // }
      if (
        searchValue.length > 0 ||
        searchByName ||
        // searchByVenue ||
        // functionDate ||
        // followupDate ||
        searchByNo ||
        searchByWhatsappStatus ||
        searchByCompanyName
      ) {
        const advanceFilter = [...searchValue];

        if (searchByName) {
          advanceFilter.push({
            column: ["name"],
            value: searchByName,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }

        // if (searchByVenue) {
        //   advanceFilter.push({
        //     column: ["preferred_venue"],
        //     value: searchByVenue,
        //     logicalOperator: "AND",
        //     operator: "CONTAINS",
        //   });
        // }

        // if (functionDate) {
        //   advanceFilter.push({
        //     column: ["function_date"],
        //     value: functionDate,
        //     logicalOperator: "AND",
        //     operator: "CONTAINS",
        //   });
        // }

        // if (followupDate) {
        //   advanceFilter.push({
        //     column: ["followup_date"],
        //     value: followupDate,
        //     logicalOperator: "AND",
        //     operator: "CONTAINS",
        //   });
        // }

        if (searchByNo) {
          // advanceFilter.push({
          //   column: ["representative_contact"],
          //   value: searchByNo,
          //   logicalOperator: "AND", // Connects to previous filters with AND
          //   operator: "CONTAINS",
          // });

          // Use OR for subsequent conditions to check "any" of the fields
          advanceFilter.push({
            column: ["contact"],
            value: searchByNo,
            logicalOperator: "OR", // OR with the previous condition
            operator: "CONTAINS",
          });

          // advanceFilter.push({
          //   column: ["alternate_contact"],
          //   value: searchByNo,
          //   logicalOperator: "OR", // OR with the previous conditions
          //   operator: "CONTAINS",
          // });
        }

        if (searchByWhatsappStatus) {
          advanceFilter.push({
            column: ["whatsapp_status"],
            value: searchByWhatsappStatus,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }

        if (searchByCompanyName) {
          advanceFilter.push({
            column: ["company_name"],
            value: searchByCompanyName,
            logicalOperator: "AND",
            operator: "CONTAINS",
          });
        }

        url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
      }

      let from_date = formatDate2(date.fromDate);
      let to_date = formatDate2(date.toDate);

      let finalUrl =
        `${endPoints.LeadsfromWebsite.fetchLeadsfromWebsite}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${from_date}&to_date=${to_date}` +
        url;

      if (
        searchByName ||
        // searchByVenue ||
        searchByNo ||
        searchByWhatsappStatus ||
        status !== "-1"
      ) {
        finalUrl =
          `${endPoints.LeadsfromWebsite.fetchLeadsfromWebsite}?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}` +
          url;
      }

      const res = await api.get(finalUrl);
      const data: ILeadfromWebsite[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsFromWebsiteSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsFromWebsiteFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data?.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const fetchDashboardLeadsListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    status: string,
    // searchValue: IDatatableV2AdvancedSearchFilter,
    date: string,
    company_outlet_uuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      // const searchQuery = getSearchQuery(queryParams);
      dispatch(fetchLeadsFromWebsiteProgress());
      // dispatch(saveLoaderProgress());

      let url = "";
      if (status !== "-1") {
        url += `&status=${status}`;
      }
      // if (searchValue.length > 0) {
      //   url += `&advanceFilter=${JSON.stringify(searchValue)}`;
      // }
      // if (company_outlet_uuid) {
      //   url += `&company_outlet_uuid=${company_outlet_uuid}`;
      // }
      let finalUrl =
        `${endPoints.LeadsfromWebsite.fetchLeadsfromWebsite}?pageNo=${pageNumber}&itemPerPage=${rowsInPerPage}&column=followup_date&value=` +
        date +
        url;
      const res = await api.get(finalUrl);
      const data: ILeadfromWebsite[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      dispatch(fetchLeadsFromWebsiteSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchLeadsFromWebsiteFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_LEAD_PROGRESS = "FETCH_LEAD_PROGRESS";
export const FETCH_LEAD_SUCCESS = "FETCH_LEAD_SUCCESS";
export const FETCH_LEAD_FAILED = "FETCH_LEAD_FAILED";

export const fetchLeadProgress = () => action(FETCH_LEAD_PROGRESS);
export const fetchLeadSuccess = (leadfromWebsite: ILeadfromWebsite) =>
  action(FETCH_LEAD_SUCCESS, { leadfromWebsite });
export const fetchLeadFailed = (errorMessage: string) =>
  action(FETCH_LEAD_FAILED, { errorMessage });

export const fetchLeadAsync =
  (leadId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchLeadProgress());
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `${endPoints.LeadsfromWebsite.fetchLeadsfromWebsite}?enquiry_request_uuid=${leadId}`
      );
      const data = res.data.data;
      if (data.length > 0) {
        dispatch(fetchLeadSuccess(data[0]));
      } else {
        dispatch(
          fetchLeadFailed(
            "Unfortunately, there are no records available at the moment."
          )
        );
      }
    } catch (err: any) {
      dispatch(fetchLeadFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const UPDATE_LEAD_FROM_WEBSITE_PROGRESS = "UPDATE_LEAD_FROM_WEBSITE_PROGRESS";
export const UPDATE_LEAD_FROM_WEBSITE_SUCCESS = "UPDATE_LEAD_FROM_WEBSITE_SUCCESS";
export const UPDATE_LEAD_FROM_WEBSITE_FAILED = "UPDATE_LEAD_FROM_WEBSITE_FAILED";

export const updateLeadFromWebsiteProgress = () => action(UPDATE_LEAD_FROM_WEBSITE_PROGRESS);
export const updateLeadFromWebsiteSuccess = (updatedLead: ILeadfromWebsite) =>
  action(UPDATE_LEAD_FROM_WEBSITE_SUCCESS, { updatedLead });
export const updateLeadFromWebsiteFailed = (errorMessage: string) =>
  action(UPDATE_LEAD_FROM_WEBSITE_FAILED, { errorMessage });

export const updateLeadFromWebsite =
  (leadData: ILeadfromWebsite,    onCallBack: (isSuccess?: boolean, data?: ILeadfromWebsite) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(updateLeadFromWebsiteProgress());
      dispatch(saveLoaderProgress());

      const res = await api.post(
        `${endPoints.LeadsfromWebsite.upsertLeadsfromWebsite}`,
        leadData
      );
      
      const updatedLead: ILeadfromWebsite = res.data.data;
      
      dispatch(updateLeadFromWebsiteSuccess(updatedLead));
      dispatch(
        showMessage({
          type: "success",
          message: "Lead updated successfully",
          displayAs: "snackbar",
        })
      );
      
      // Optionally, you might want to refetch the leads list here
      // dispatch(fetchLeadsFromWebsiteAsync(...));
            onCallBack(true, updatedLead);


    } catch (err: any) {
      onCallBack(false);
      const errorMessage = err.response?.data?.message || "Failed to update lead";
      dispatch(updateLeadFromWebsiteFailed(errorMessage));
      dispatch(
        showMessage({
          type: "error",
          message: errorMessage,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };


export const CLEAR_LEAD_FROM_WEBSITE_STATE = "CLEAR_LEAD_FROM_WEBSITE_STATE";
export const CLEAR_LEAD_FROM_WEBSITE = "CLEAR_LEAD_FROM_WEBSITE";

export const clearLeadsFromWebsiteState = () => action(CLEAR_LEAD_FROM_WEBSITE_STATE);
export const clearLeadFromWebsite = () => action(CLEAR_LEAD_FROM_WEBSITE);
